export default "/logoMobile.a8d19c644b2709049bc0c822e6f40a00.svg";